import { Component, EventEmitter, Input, Output } from '@angular/core';

import { PersonalDetailsCurrentScreen } from '@shared/models/Profile';

@Component({
  selector: 'app-profile-field-row',
  templateUrl: './profile-field-row.component.html',
  styleUrls: ['./profile-field-row.component.scss'],
  standalone: false
})
export class ProfileFieldRowComponent {
  @Input() showEdit = true;
  @Input() label: string;
  @Input() content: string;
  @Input() screen: PersonalDetailsCurrentScreen;
  @Output() changeScreen = new EventEmitter<PersonalDetailsCurrentScreen>();

  clickEditButton(): void {
    this.changeScreen.emit(this.screen);
  }
}
